// extracted by mini-css-extract-plugin
export var highlight = "card-job-highlights-module--highlight--2ce73";
export var highlightLeft__chart = "card-job-highlights-module--highlight-left__chart--02c12";
export var highlightLeft__education = "card-job-highlights-module--highlight-left__education--32189";
export var highlightLeft__heat = "card-job-highlights-module--highlight-left__heat--a1f83";
export var highlightLeft__salary = "card-job-highlights-module--highlight-left__salary--794e9";
export var highlightRight = "card-job-highlights-module--highlight-right--fa62d";
export var root = "card-job-highlights-module--root--19de8";